<template>
  <v-dialog v-model="show" max-width="800" :fullscreen="isMobile" persistent>
    <v-card flat>
      <v-card-title>
        <div class="headline">Results</div>
      </v-card-title>
      <v-container>
        <v-row justify="center">
          <v-col cols="4">
            <div class="text-center">
              <v-icon color="primary" x-large>mdi-account-group-outline</v-icon>
            </div>
            <div class="headline text-center">{{ totals.visitors | mkF }}</div>
            <div class="body-1 text-center">Estimated Visitors</div>
          </v-col>
          <v-col cols="4">
            <div class="text-center">
              <v-icon color="primary" x-large>mdi-clock-outline</v-icon>
            </div>
            <div class="headline text-center">{{ totals.lengthOfStay | round25F }} days</div>
            <div class="body-1 text-center">Length of Stay</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <trend-sparkline title="Visits By Month" height="250" :data="data" />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn text outlined color="error" @click="reset">Reset</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sum, mean } from 'lodash';
import { mk, round25, formatPercent } from '@/lib/utils';
import TrendSparkline from '@/components/TrendSparkline';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },

    data: {
      type: Array,
      default: () => []
    }
  },

  components: {
    TrendSparkline
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },

    totals() {
      return {
        visitors: sum(this.data.map((d) => Number(d.extrapolated_devices))),
        lengthOfStay: mean(this.data.map((d) => Number(d.length_of_stay)))
      };
    }
  },

  methods: {
    reset() {
      this.$emit('update:show', false);
      this.$emit('reset');
    }
  },

  filters: {
    mkF: mk,
    round25F: round25,
    formatPercentF: formatPercent
  }
};
</script>
